import React, { Fragment, useEffect, useRef, useState } from "react";
import M from "materialize-css";

import { useAuth } from "../Context/Context";
import { leerDatosSesion, limpiarSesion } from "../Helpers/sesion";
import { etiquetaTipo } from "../Helpers/tiposAdmin";

import logo from "../Images/logo.png";

import "./SideNav.css";

// `tipos`: tipos de usuario que ven el enlace; `activo`: prefijo de ruta que lo marca como actual (si difiere de href)
const GRUPOS = [
  {
    titulo: "Sitio con vista previa",
    enlaces: [
      { href: "/calendario", texto: "Calendario", tipos: ["0"] },
      { href: "/proceso-admision", texto: "Inscripción", tipos: ["0"] },
      { href: "/reinscripcion", texto: "Reinscripción", tipos: ["0"] },
      { href: "/licenciaturas/cine", activo: "/licenciaturas", texto: "Licenciaturas", tipos: ["0"] },
      { href: "/aviso-inicio", texto: "Aviso de inicio", tipos: ["0"] },
      { href: "/noticias", texto: "Noticias", tipos: ["0"] },
      { href: "/becas", texto: "Becas", tipos: ["0"] },
      { href: "/baners", texto: "Banners", tipos: ["0"] },
      { href: "/directorio", texto: "Directorio", tipos: ["0"] },
      { href: "/profesores", texto: "Docentes", tipos: ["0"] },
    ],
  },
  // Ocultas: el sitio ya no muestra estas secciones (la ruta /titulaciones está comentada y FAQs no se usa).
  // Las vistas y rutas del admin se conservan por si se vuelven a publicar; para mostrarlas, descomentar este grupo.
  // {
  //   titulo: "Más secciones del sitio",
  //   enlaces: [
  //     { href: "/preguntas-frecuentes", texto: "Preguntas frecuentes", tipos: ["0"] },
  //     { href: "/titulaciones", texto: "Titulaciones (pendiente)", tipos: ["0"] },
  //   ],
  // },
  {
    titulo: "Cursos",
    enlaces: [
      { href: "/cursos-diplomados", texto: "Cursos, talleres y diplomados", tipos: ["0", "1"] },
      { href: "/etiquetas", texto: "Etiquetas de cursos", tipos: ["0", "1"] },
      { href: "/profesores-cursos", texto: "Profesores de cursos", tipos: ["0", "1"] },
    ],
  },
  {
    titulo: "Blogs",
    enlaces: [
      { href: "/blogs-noticias", texto: "Blogs y noticias", tipos: ["0"] },
      { href: "/etiquetas-blogs", texto: "Etiquetas de blogs", tipos: ["0"] },
      { href: "/autores-blogs", texto: "Autores de blogs", tipos: ["0"] },
    ],
  },
  {
    titulo: "Solicitudes y mensajes",
    enlaces: [
      { href: "/solicitud-inscripciones", texto: "Solicitudes de inscripción (L)", tipos: ["0", "5"] },
      { href: "/archivos-inscripciones", texto: "Archivos de inscripción (P)", tipos: ["0"] },
      { href: "/solicitud-reinscripciones", texto: "Solicitudes de reinscripción (L)", tipos: ["0", "5"] },
      { href: "/archivos-reinscripciones", texto: "Archivos de reinscripción (P)", tipos: ["0"] },
      { href: "/mensajes", texto: "Mensajes de contacto", tipos: ["0"] },
    ],
  },
  {
    titulo: "Estudiantes",
    enlaces: [{ href: "/estudiantes", texto: "Estudiantes", tipos: ["0", "4"] }],
  },
  {
    titulo: "Administración",
    enlaces: [{ href: "/administradores", texto: "Administradores", tipos: ["0"] }],
  },
];

const PALABRAS_MENORES = ["de", "del", "la", "las", "los", "y", "e"];

const iniciales = (nombre = "") =>
  nombre
    .split(/\s+/)
    .filter((palabra) => palabra && !PALABRAS_MENORES.includes(palabra.toLowerCase()))
    .slice(0, 2)
    .map((palabra) => palabra[0].toUpperCase())
    .join("");

const esActivo = ({ href, activo = href }) => {
  const ruta = window.location.pathname;
  return ruta === activo || ruta.startsWith(activo + "/");
};

const SideNav = () => {
  const { user, setUser } = useAuth();
  const [menuPerfil, setMenuPerfil] = useState(false);
  const perfilRef = useRef(null);

  useEffect(() => {
    var elems = document.querySelectorAll(".sidenav");
    M.Sidenav.init(elems);

    const datos = leerDatosSesion();
    if (datos) setUser(datos);
  }, []);

  useEffect(() => {
    if (!menuPerfil) return;
    const cerrarFuera = (evento) => {
      if (!perfilRef.current?.contains(evento.target)) setMenuPerfil(false);
    };
    const cerrarEscape = (evento) => evento.key === "Escape" && setMenuPerfil(false);
    document.addEventListener("mousedown", cerrarFuera);
    document.addEventListener("keydown", cerrarEscape);
    return () => {
      document.removeEventListener("mousedown", cerrarFuera);
      document.removeEventListener("keydown", cerrarEscape);
    };
  }, [menuPerfil]);

  const cerrarSesion = () => {
    limpiarSesion();
    window.location.replace("/");
  };

  const tipoUsuario = etiquetaTipo(user.tipo);
  const grupos = GRUPOS.map((grupo) => ({
    ...grupo,
    enlaces: grupo.enlaces.filter(({ tipos }) => tipos.includes(String(user.tipo))),
  })).filter((grupo) => grupo.enlaces.length);

  return (
    <Fragment>
      <header className="nav_admin">
        <div className="nav_admin_izquierda">
          <a href="#!" data-target="slide-out" className="sidenav-trigger nav_admin_menu" aria-label="Abrir menú">
            <i className="material-icons">menu</i>
          </a>
          <img src={logo} alt="CAAV" className="nav_admin_logo" />
          <span className="nav_admin_titulo">Panel de administración</span>
        </div>

        <div className="nav_admin_perfil" ref={perfilRef}>
          <button
            type="button"
            className="nav_admin_perfil_boton"
            onClick={() => setMenuPerfil((abierto) => !abierto)}
            aria-expanded={menuPerfil}
          >
            <span className="nav_admin_avatar">{iniciales(user.nombre)}</span>
            <span className="nav_admin_perfil_texto">
              <span className="nav_admin_perfil_nombre">{user.nombre}</span>
              {user.nombre !== tipoUsuario && <span className="nav_admin_perfil_tipo">{tipoUsuario}</span>}
            </span>
            <i className="material-icons nav_admin_perfil_flecha">{menuPerfil ? "expand_less" : "expand_more"}</i>
          </button>

          {menuPerfil && (
            <div className="nav_admin_perfil_menu">
              <div className="nav_admin_perfil_menu_encabezado">
                <span className="nav_admin_avatar nav_admin_avatar_grande">{iniciales(user.nombre)}</span>
                <div>
                  <p className="nav_admin_perfil_nombre">{user.nombre}</p>
                  <p className="nav_admin_perfil_tipo">{tipoUsuario}</p>
                </div>
              </div>
              <a href={`/administrador/${user.id}`} className="nav_admin_perfil_opcion">
                <i className="material-icons">person</i>
                Mi perfil
              </a>
              <button type="button" onClick={cerrarSesion} className="nav_admin_perfil_opcion nav_admin_perfil_salir">
                <i className="material-icons">logout</i>
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </header>

      <ul id="slide-out" className="sidenav nav_admin_cajon">
        <li className="nav_admin_cajon_logo">
          <a target="_blank" rel="noopener noreferrer" href="https://caav.mx/">
            <img alt="CAAV" src={logo} />
          </a>
        </li>
        {grupos.map((grupo) => (
          <Fragment key={grupo.titulo}>
            <li className="nav_admin_grupo">{grupo.titulo}</li>
            {grupo.enlaces.map((enlace) => (
              <li key={enlace.href}>
                <a href={enlace.href} className={"nav_admin_enlace" + (esActivo(enlace) ? " nav_admin_enlace_activo" : "")}>
                  {enlace.texto}
                </a>
              </li>
            ))}
          </Fragment>
        ))}
      </ul>
    </Fragment>
  );
};

export default SideNav;
